import React, { useState, useEffect } from 'react';
import gt_seal from '../../static/georgia_tech_seal.png';
import gt_campus from '../../static/gtcampus_2.jpg';

function Grad() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth);
    });
  }, []);

  return (
    <div className='card-right'>
      <div className='card-content-left crop'>
        <img className='card-image' src={gt_campus}/>
      </div>
      <div className='card-content-right'>
        <div className='card-title-box'>
          <div className='card-title-logo'>
            <img className="card-logo" src={gt_seal}/>
          </div>
          <div className='card-title'>
            {/* <h5>Education</h5> */}
            {
              width < 707
              ? <h2>Georgia Tech</h2>
              : <h2>Georgia Institute of Technology</h2>
            }
            <h5>Atlanta, GA</h5>
          </div>
        </div>
        <div className='card-details-box'>
          <h4>M.S. Computer Science</h4>
          <h5>Aug 2022 - May 2024</h5>
        </div>
        <div className='card-content'>
          <div className='child-div'>
            <p>
              My focus was mostly in <b>Artificial Intelligence</b> and <b>Machine Learning</b>, but I also spent a significant amount of time pursuing my interests in interactive <b>Data Visualization</b>.
            </p>
          </div>
          <div className='child-div'>
            <p>
              Outside of coursework, I have been serving as a <b>Teaching Assistant</b> for Georgia Tech's On-Campus and OMSCS <b>Artificial Intelligence</b> course since Spring 2023.
            </p>
          </div>
          <div className='child-div'>
            <h5>Notable Coursework</h5>
            <ul style={{marginLeft: "1.5rem"}}>
              <li><a href='https://omscs.gatech.edu/cs-6601-artificial-intelligence' target='_blank'>Artifical Intelligence</a> - Prof. Ploetz</li>
              <li><a href='https://omscs.gatech.edu/cs-7641-machine-learning' target='_blank'>Machine Learning</a> - Prof. Roozbahani</li>
              <li><a href='https://omscs.gatech.edu/cs-7650-natural-language-processing' target='_blank'>Natural Language Processing</a> - Prof. Ritter</li>
              <li><a href='https://omscs.gatech.edu/cse-6242-data-visual-analytics' target='_blank'>Data and Visual Analytics</a> - Prof. Polo</li>
            </ul>
          </div>
          <div className='child-div'>
            <h5>Interesting Projects</h5>
            <ul style={{marginLeft: "1.5rem"}}>
              <li><a href='https://jray810.github.io/cs7450_hw5/' target='_blank'>Visualizing US Presidents and the Electoral College</a></li>
              <li><a href='https://jray810.github.io/ML_SleepStageIdentification/' target='_blank'>Evaluating Single Channels for Sleep Stage Identification</a></li>
              {/* <li>Visualizing Beijing Air Quality Data</li> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Grad;